import { getDefaultConfig } from './Store';

export const DPP_STAGING_USERTYPE_PREFIX = 'staging';

//userTypes for qa and prod: 'new', 'existing', 'churned'
//userTypes for staging: 'stagingNew', 'stagingExisting', 'stagingChurned'
export const getUserType = (hasActiveSubscription, isChurnedUser) => {
  const { appEnv } = getDefaultConfig();

  let userType = 'new';
  if (hasActiveSubscription) {
    userType = 'existing';
  } else if (isChurnedUser) {
    userType = 'churned';
  }

  if (appEnv === 'staging') {
    userType = `${DPP_STAGING_USERTYPE_PREFIX}${userType.charAt(0).toUpperCase() + userType.substring(1)}`;
  }

  return userType;
};
